import { css } from '@emotion/core'
import * as React from 'react'

import { glossaryAlphabetBreakPoint, headerBreakPoint } from '../../constants/breakPoints'
import { breakpoints } from '../../constants/breakPoints'
import { HEADER_HEIGHT } from '../../constants/header'
import { isMobile } from '../../helpers/common'
import { useDetectSticky } from '../../hooks/useStickyObserver'
import { GlossaryAlphabetBlockProps } from '../../interfaces/glossary'
import Block from './../Block'

// export for glossary.tsx & glossaryTerm.tsx
export const alphabeticalRegisterHeight = isMobile(breakpoints.small) ? 0 : isMobile(headerBreakPoint) ? 55 : 63

const GlossaryAlphabetBlock: React.FunctionComponent<GlossaryAlphabetBlockProps> = ({
  idPrefix = '',
  search,
  register,
  filteredRegister,
  // referenceIdForStickyPos is either window ("") or
  // the id of the block on which the <AlphabeticalRegister /> should be sticky on
  referenceIdForStickyPos = '',
  cssStyles = css``,
}) => {
  return (
    <div
      id={`${idPrefix}alphabetical-register`}
      className={'full-screen-sticky'}
      css={[
        alphabeticalRegisterStyle(
          search,
          useDetectSticky(`${idPrefix}alphabetical-register`, HEADER_HEIGHT, referenceIdForStickyPos)
        ),
        cssStyles,
      ]}
    >
      <Block
        columns={register.length}
        columnsTemplate={`repeat(${register.length}, min-content)`}
        columnGap={1}
        rowGap={1}
        css={lettersContainerStyle}
      >
        {register
          .filter(({ character }) =>
            isMobile(glossaryAlphabetBreakPoint) && !isMobile(breakpoints.small) ? character !== '#' : character
          )
          .map((entry) => (
            <div key={entry.character} className={'center'}>
              {entry.terms.length > 0 && filteredRegister.find(({ character }) => character === entry.character) ? (
                <a
                  className={'blue-text opacity-on-hover'}
                  onClick={() => {
                    document
                      .getElementById(`${idPrefix}${entry.character.toLowerCase()}`)
                      ?.scrollIntoView({ behavior: 'smooth' })
                  }}
                >
                  {entry.character}
                </a>
              ) : (
                <span className={'gray-text'}>{entry.character}</span>
              )}
            </div>
          ))}
      </Block>
    </div>
  )
}

export default GlossaryAlphabetBlock

const alphabeticalRegisterStyle = (search: string, isStuck: boolean) => css`
  z-index: 2;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(20px);
  position: sticky;
  top: ${HEADER_HEIGHT}px;
  margin-top: ${search ? '8rem' : '4rem'};
  padding: 1rem 2rem;
  border-bottom: 1px solid ${isStuck ? '#efeff0' : 'transparent'};

  @media screen and (max-width: ${headerBreakPoint}px) {
    padding: 0.75rem 2rem;
  }

  @media screen and (max-width: ${glossaryAlphabetBreakPoint}px) {
    // not sicky any more: remove margin-top & padding-top
    position: initial;
    margin-top: 0;
    padding-top: 0;
    border: none;
  }
`

const lettersContainerStyle = css`
  font-size: 1.25rem;
  width: fit-content;

  @media screen and (max-width: ${glossaryAlphabetBreakPoint}px) {
    grid-template-columns: repeat(13, min-content);
  }

  @media screen and (max-width: ${breakpoints.small}px) {
    grid-template-columns: repeat(9, min-content) !important;
  }
`
